module.exports = __webpack_public_path__ + "static/media/login-img.123d2184.png";


//////////////////
// WEBPACK FOOTER
// ./src/login-img.png
// module id = 703
// module chunks = 0